import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { GiResize } from 'react-icons/gi';
import { Button, NumericInput } from '@blueprintjs/core';

export const MaSizePanel = observer(({ store }) => {

  const AVAILABLE_SIZES = [
    { name: 'Full HD Horizontal', width: 1920, height: 1080, icon: 'vertical-distribution' },
    { name: 'Full HD Vertical', width: 1080, height: 1920, icon: 'horizontal-distribution' },
  ];

  return (
    <div>
      <div style={{ height: '45px', paddingTop: '5px' }}>Escolha o tamanho da tela: </div>

      <div style={{ paddingBottom: '15px' }}>
        <div style={{ display: 'inline-block', width: '50%' }}>Comprimento</div>
        <div style={{ display: 'inline-block', width: '50%' }}>
          <NumericInput
            buttonPosition='none'
            defaultValue='1920'
            value={store.width}
            fill
            onValueChange={(e) => store.setSize(e, store.height)}
          />
        </div>
      </div>

      <div style={{ paddingBottom: '25px' }}>
        <div style={{ display: 'inline-block', width: '50%' }}>Altura</div>
        <div style={{ display: 'inline-block', width: '50%' }}>
          <NumericInput
            buttonPosition='none'
            value={store.height}
            fill
            onValueChange={(e) => store.setSize(store.width, e)}
          />
        </div>
      </div>

      {AVAILABLE_SIZES.map(({ name, width, height, icon }, i) => (
        <Button
          minimal
          outlined
          icon={icon}
          key={i}
          style={{ width: '100%', marginBottom: '20px', fontSize: '0.7rem' }}
          onClick={() => {
            store.setSize(width, height);
          }}
        >
          <span style={{ display: 'inline-block', marginRight: '20px', fontSize: '14px' }}>{name}</span>
          {width}x{height}
        </Button>
      ))}
    </div>
  );
});

export const MaSizesSection = {
  name: 'sizes',
  Tab: (props) => (
    <SectionTab name='Tamanhos' {...props}>
      <GiResize />
    </SectionTab>
  ),
  Panel: MaSizePanel,
};